import { render, staticRenderFns } from "./related-auction-list.vue?vue&type=template&id=e7e18c58&"
import script from "./related-auction-list.vue?vue&type=script&lang=js&"
export * from "./related-auction-list.vue?vue&type=script&lang=js&"
import style0 from "./related-auction-list.vue?vue&type=style&index=0&id=e7e18c58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSeparator,QScrollArea,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSeparator,QScrollArea,QImg})
